import BerandaPage from "./BerandaPage";
function HomePage() {
    return (
        <div>
            <BerandaPage />
        </div>
    );
}

export default HomePage;
